import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ConfigurationService } from './configuration.service';
import { Router } from '@angular/router';
import { DataManipulateService } from './data-manipulate.service';
@Injectable()
export class AuthService {

    private baseURL = "";
    private currentUserSubject: BehaviorSubject<any>;
    public currentUser: Observable<any>;

    constructor(private http: HttpClient, private config: ConfigurationService,private route:Router, private data:DataManipulateService) {
        this.baseURL = config.getBaseUrl()
        let currentUser = localStorage.getItem('currentUser');
        if(currentUser) currentUser = JSON.parse(currentUser)
        this.currentUserSubject = new BehaviorSubject<any>(currentUser);
        this.currentUser = this.currentUserSubject.asObservable();
    }

    public get currentUserValue(): any {
        return this.currentUserSubject.value;
    }



    loginsignup(params:any) {
        const criteria = {
            "criteria": {
                ...params
            }
        };
        return this.http.post<any>(this.baseURL + "master/userLogin", criteria).pipe(
            map(data => {
                // console.log(data);

                if (data && data?.Data?.token) {
                    // console.log(true);

                    this._syncUser(data);
                }
                return data;
            }));
    }

    logout() {
        // remove user from local storage to log user out
        // localStorage.removeItem('currentUser');
        this.route.navigateByUrl("/login");
        // this.currentUserSubject.next(null);
        this.data.Token='';
        this.data.userInfo={};
    }

    _syncUser(data:any) {
        // localStorage.setItem('currentUser', JSON.stringify(data));
        this.currentUserSubject.next(data);
    }

}
